import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Switch } from "antd";
import { AiOutlineHolder } from "react-icons/ai";

import type { EnhancedColumnType } from "../../types";

import s from "./SortableItem.module.css";

interface SortableItemProps {
  item: EnhancedColumnType<any>;
  onToggle: (checked: boolean, item: EnhancedColumnType<any>) => void;
}

export const SortableItem = ({ item, onToggle }: SortableItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id as string });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <section
      ref={setNodeRef}
      style={style}
      className={s.item}
      data-testid="sortable-item"
    >
      <div {...attributes} {...listeners} className={s.dragHandle}>
        <AiOutlineHolder />
      </div>
      <div className={s.title}>{item.title as string}</div>
      <Switch
        checked={item.visible}
        onChange={checked => onToggle(checked, item)}
        data-testid={`toggle-visibility-${item.dataIndex}`}
      />
    </section>
  );
};
